import React from 'react'
import PropTypes from 'prop-types'

import Spinner from 'lib/tags/spinner'

// NB: Settings isDisabled = true will just change the color of the button.
// It will still have an onClick, as this is expected to be delegated to redux-form which will show validation errors.

const Button = ({
  isSubmitting,
  isStyleDisabled,
  disabled,
  className,
  onClick,
  color,
  backgroundColor,
  style,
  children,
  centered,
  content,
  dataAttr
}) => {
  return (
    <button
      style={centered ? { ...(style || {}), display: 'block', margin: '0 auto' } : style}
      className={`btn-${color}-${backgroundColor} ${className} ${isStyleDisabled ? 'btn-disabled' : ''}`}
      onClick={onClick}
      disabled={disabled}
      type='button'
      data-attr={dataAttr}
    >
      {isSubmitting ? <Spinner color={isStyleDisabled ? 'white' : color} /> : content || children}
    </button>
  )
}

Button.propTypes = {
  isSubmitting: PropTypes.bool,
  isStyleDisabled: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  centered: PropTypes.bool,
  content: PropTypes.string,
  dataAttr: PropTypes.string
}

export default Button
